import React from 'react';
import Content from './Component/Content';
import Cookie from 'react-cookies';
import BreadCrumb from './Component/BreadCrumb';
import Helper from './Component/Helper';
import NumberFormat from "react-number-format";
import ReactDOMServer from 'react-dom/server';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Swiper, Navigation, Pagination, Scrollbar, Autoplay } from 'swiper';
import "./App.css";

var isProduction = true;
Helper.setSiteUrl("http://pibook.local/", "https://pibook.vn", isProduction);

export const notify = (type, message) => toast(message, {
  type: type
});

class App extends React.Component {
  constructor(props){
    super(props);
    let cart = [];
    if(Storage)
    {
        cart = localStorage.getItem('cart') ? JSON.parse(localStorage.getItem('cart')):[];
    }
    // let expires = new Date();
    // expires.setTime(expires.getTime() + 1000 * 60 * 60 * 24 * 7);
    
    // Cookie.save('pbuniq','11840',{path: '/', expires: expires});
    let account = window.MEMBER,
    accountLogin=Cookie.load('pbuniq');
    account = accountLogin && accountLogin === account.id ? account:false;
    this.state = {
      account: account,
      error: null,
      isLoaded: false,
      product: false,
      relation:false,
      wishlist: window.WISHLIST_LIST ?? false,
      cart: cart,
      isShowForm:false,
      showContent: 'field',
      modalShow:false,
      preAmount:0
    };
  }

  //Show form write new comment
  handleShowForm = (flag)=>{
    let {account} = this.state;
    if(!account)
    {
      window.location.href = '/dang-nhap/?redirect='+encodeURIComponent(window.location.href);
      return false;
    }
    this.setState({
      isShowForm:flag
    });
  }
  handleCloseModal = ()=>{
    this.setState({
      modalShow:false,
      preAmount:0
    })
  }
  onClickAddToCart=(cart, redirect)=>{
    const $ = window.jQuery;
    if(!cart) return;
    localStorage.setItem('cart', JSON.stringify(cart));
    $('html, body').animate({
        scrollTop: $("#container").offset().top
    }, 500);
    $('body').append('<div class="loading-img"></div>');
    !$('.alert').length && $('#container .container-fluid ').prepend(`<div class="alert alert-success mt-2 alert-dismissible fade show" role="alert">
    Thêm mới thành công
    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>`);
    setTimeout(() => {
      this.setState({cart:cart});
      redirect && (window.location.href='/gio-hang');
    }, 200);
  };

  handleChangeReviewTab = (showContent)=>{
    const $ = window.jQuery;
    $('body').append('<div class="loading-img"></div>');
    setTimeout(() => {
      this.setState({
        showContent:showContent
      })
    }, 100);
  }
  handlePreOrder = (amount)=>{
    this.setState({
      preAmount:parseInt(amount),
      modalShow:true
    })
  }
  handleAddtoWishlist = (productId)=>{
    let {account} = this.state;
    if(!account || !Object.entries(account).length)
    {
      window.location.href="/dang-nhap?redirect="+encodeURIComponent(window.location.href);
      return false;
    }
      
    fetch(Helper.getSiteUrl() + '/post/SubmitWishlist', {
            method: 'POST',
            body: `{"product_id":"${productId}","member_id":"${account.id}"}`,
        }).then(res => res.text()).then(
            (result)=>{
              result = JSON.parse(result);
              result.response === 'success' && 
              window.location.reload();
            }
        );
  }
  componentDidMount(){
    let lastSegmentUrl = Helper.getLastSegmentUrl();
    if(lastSegmentUrl === 'show-404' )
      return;
    let alias = lastSegmentUrl.replace('.html','');
    Promise.all([
      fetch(Helper.getSiteUrl() + '/post/getAjaxProductDetail/', {
        method: 'POST',
        body: JSON.stringify({alias:alias}),
      }),
      fetch(Helper.getSiteUrl() + '/post/getAjaxProductRelate/', {
        method: 'POST',
        body: JSON.stringify({slug:alias}),
      }),
    ]).then(([res1,res2])=>{
        // console.log(res1.text(),res2.text());
        return Promise.all([res1.json(),res2.json()])
    }).then(([res1,res2])=>{
        if(res1 && !res1.err) {
          this.setState({
            product:res1,
            isLoaded: true,
          });
          
        }else{
          this.setState({
            isLoaded: false,
            error: res1.err
          })
        }
        if(res2 && !res2.err) {
          this.setState({
            relation:res2
          });
        }
    }).then(()=>{
      let $ = window.jQuery;
      $('[data-fancybox="gallery"]').fancybox({
          loop: true
      });

      Swiper.use([Navigation, Pagination, Scrollbar, Autoplay]);
      // Now you can use Swiper
      let swiper = new Swiper('.relate__card__swiper-container', {
        slidesPerView: 5,
        spaceBetween : 0,
        effect: 'slide',
        loop: true,
        autoplay: {
            delay: 8000,
            disableOnInteraction: false
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });

      let direction = 'vertical',
      navigation = {
          nextEl: '.swiper-button-vertical-next',
          prevEl: '.swiper-button-vertical-prev',
      }
      
      if($(window).width() < 576){
        direction = 'horizontal';
        navigation = {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        };
      }
      Swiper.use([Navigation, Pagination, Scrollbar, Autoplay]);
      // Now you can use Swiper
      let swiper2 = new Swiper('.image-slider', {
        slidesPerView: 3,
        spaceBetween : 20,
        effect: 'slide',
        direction:direction,
        loop: false,
        // autoplay: {
        //     delay: 8000,
        //     disableOnInteraction: false
        // },
        navigation: navigation,
      });
    })

    // fetch(Helper.getSiteUrl() + '/post/getAjaxProductDetail/', {
    //   method: 'POST',
    //   body: JSON.stringify({alias:alias}),
    // }).then(res=>res.json())
    // .then((result)=>{
    //   if(result && !result.err)
    //   {
    //     this.setState({
    //       product:result,
    //       isLoaded: true,
    //     });
    //     let $ = window.jQuery;
    //     $('[data-fancybox="gallery"]').fancybox({
    //         loop: true
    //     });

    //     Swiper.use([Navigation, Pagination, Scrollbar, Autoplay]);
    //     // Now you can use Swiper
    //     let swiper = new Swiper('.relate__card__swiper-container', {
    //       slidesPerView: 5,
    //       spaceBetween : 0,
    //       effect: 'slide',
    //       loop: true,
    //       autoplay: {
    //           delay: 8000,
    //           disableOnInteraction: false
    //       },
    //       navigation: {
    //         nextEl: '.swiper-button-next',
    //         prevEl: '.swiper-button-prev',
    //       },
    //     });

    //     let direction = 'vertical',
    //     navigation = {
    //         nextEl: '.swiper-button-vertical-next',
    //         prevEl: '.swiper-button-vertical-prev',
    //     }
        
    //     if($(window).width() < 576){
    //       direction = 'horizontal';
    //       navigation = {
    //         nextEl: '.swiper-button-next',
    //         prevEl: '.swiper-button-prev',
    //       };
    //     }
    //     Swiper.use([Navigation, Pagination, Scrollbar, Autoplay]);
    //     // Now you can use Swiper
    //     let swiper2 = new Swiper('.image-slider', {
    //       slidesPerView: 3,
    //       spaceBetween : 20,
    //       effect: 'slide',
    //       direction:direction,
    //       loop: false,
    //       // autoplay: {
    //       //     delay: 8000,
    //       //     disableOnInteraction: false
    //       // },
    //       navigation: navigation,
    //     });
    //   }
    //   else 
    //   {
    //     this.setState({
    //       isLoaded: false,
    //       error: result.err
    //     })
    //   }
        
    // },
    // (error) => {
    //   this.setState({
    //     isLoaded: true,
    //     error
    //   });
    // })
  }
  componentDidUpdate(){
    const $ = window.jQuery;
    // $('div.loading-img').remove();
    $('div.popup-bg').remove();
    $('.filter-toggle.sub-page-nav').hide();
    let {isShowForm} = this.state;
    isShowForm && $('body').append('<div class="popup-bg"></div>');
    let carts = localStorage.getItem('cart');
    carts = JSON.parse(carts)??[];
    if(carts.length)
    {
      $("#Header_cart span.sticky-number").length?$("#Header_cart span.sticky-number").text(carts.length):
      $("#Header_cart").append(`<span class="rounded-circle d-block position-absolute sticky-number">${carts.length}</span>`);
      
      $('#Header_cart_mobile span.sticky-number').length?$('#Header_cart_mobile span.sticky-number').text(carts.length): 
      $('#Header_cart_mobile').append(`<span class="rounded-circle d-block position-absolute sticky-number">${carts.length}</span>`);

        let cartView = carts.map((cartItem, index)=>{
          return (
            <li className="list-group-item d-flex justify-content-start py-2" key={index}>
              <a href={cartItem.link} title={cartItem.title} className="product-image">
                <img src={cartItem.image} width={60} alt={cartItem.title} />
              </a>
              <div className="product-details">
                <p><a href={cartItem.link}>{Helper.wordLimiter(cartItem.title, 10)}</a></p>
                <strong className="text-medium">{cartItem.cnt}</strong> x  
                <span className="text-medium text-danger">
                <NumberFormat value={cartItem.price} thousandSeparator="." decimalSeparator=","
                displayType={"text"} renderText={(value)=>`${value} đ`}/>
                </span>
                <a href="/gio-hang" className="text-left viewmore py-2">Chi tiết</a>
              </div>
            </li>
          );
        })

        let cartList = 
            <ul className="text-left list-group list-group-flush">
                {cartView}
            </ul>;
        const cartListHtml = ReactDOMServer.renderToString(cartList);
        
        $('#Header_cart_list').removeClass('d-none').html(cartListHtml);
    }
  }
  hanldeSubmitPreOrder = (e)=>{
    e.preventDefault();
    const $ = window.jQuery;
    $('html, body').animate({
      scrollTop: $("#container").offset().top
    }, 500);
    $('body').append('<div class="loading-img"></div>');
     let formData = new FormData(e.target);
     formData.append('product_id', this.state.product.info.product_id);
     fetch(Helper.getSiteUrl() + '/order/make_pre_order',{
       method:'POST',
       body: formData
     }).then(res=>res.json())
     .then(res=>{
        if(res && typeof res.err === 'undefined'){
          !$('.alert').length && $('.modal-content').prepend(`<div class="alert alert-success mt-2 alert-dismissible fade show" role="alert">
           Yêu cầu đặt trước thành công
          <button type="button" class="close" data-dismiss="alert" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>`);
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        }else{
          alert(res.err);
        }
     })
  }
  handleChangePreAmount=(e)=>{
    this.setState({
      preAmount: parseInt(e.target.value)
    })
  }
  
  render(){
    let {error, isLoaded, product, relation, wishlist, cart, showContent, account, isShowForm, modalShow} = this.state;
    if (error) {
      return <div>Error: {error.message}</div>;
    } else if (!isLoaded || !relation) {
      return <div>Loading...</div>;
    } else {
    return (
      <div className="app">
          <BreadCrumb product={product} />
          <Content onClickAddToCart={this.onClickAddToCart} 
          product={product} relation={relation} wishlist={wishlist} cart={cart} 
          showDetailContent={showContent} account={account}
          handleChangeReviewTab={this.handleChangeReviewTab}
          handleShowForm={this.handleShowForm}
          isShowForm={isShowForm} 
          handlePutReview={this.handlePutReview}
          handlePutReply={this.handlePutReply}
          handleAddtoWishlist={this.handleAddtoWishlist}
          handlePreOrder={this.handlePreOrder}/>
          {/* Modal */}
          <div style={{zIndex: '1002',top:'0',width:'100%',height:'100%',background:'rgba(0,0,0,.5)',
          display:`${modalShow?'block':'none'}`, position:'fixed'}}></div>
          <div style={{display:`${modalShow ? 'block' : 'none'}`}} className={`modal fade ${modalShow ? 'show':'hide'}`}
              tabIndex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
              <div className="modal-dialog" role="document">
                  <div className="modal-content">
                  <div className="modal-header">
                      <h5 className="modal-title py-0" id="exampleModalLongTitle">
                        Đặt trước sản phẩm
                      </h5>
                      <button type="button" className="close" onClick={this.handleCloseModal}>
                      <span aria-hidden="true">&times;</span>
                      </button>
                  </div>
                  <div className="modal-body text-sm">
                      <form onSubmit={this.hanldeSubmitPreOrder}>
                        <div className="form-group" style={{lineHeight:'10px'}}>
                          {product.info.title}
                        </div>
                        <div className="form-group">
                          <label>Giá</label>
                          <input type="number" readOnly name="price"
                          defaultValue={product.info.price_after_discount} className="form-control form-control-sm"/>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <div className="col-12 col-sm-6">
                              <input type="text" name="name" placeholder="Họ tên" className="form-control form-control-sm"/>
                            </div>
                            <div className="col-12 col-sm-6">
                              <input type="text" placeholder="Số điện thoại" name="phone" className="form-control form-control-sm"/>
                            </div>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <div className="col-12 col-sm-6">
                              <input type="text" placeholder="Email" name="email"  className="form-control form-control-sm"/>
                            </div>
                            <div className="col-12 col-sm-6">
                              <input min={1} max={99} onChange={this.handleChangePreAmount} value={this.state.preAmount} type="number" name="amount" placeholder="Số lượng" 
                              className="form-control form-control-sm"/>
                            </div>
                          </div>
                        </div>
                        <div className="form-group row">
                          <div className="col-12">
                            <input type="text" placeholder="Địa chỉ" name="address" className="form-control form-control-sm"/>
                          </div>
                        </div>
                        <div className="form-group text-right">
                            <button type="button" onClick={this.handleCloseModal} className="mr-2 
                              btn btn-secondary">Close</button>
                            <button className="btn btn-primary">
                              Yêu cầu đặt trước
                            </button>
                        </div>
                      </form>
                  </div>
                  </div>
              </div>
          </div>
          <ToastContainer
            autoClose={3000}
            hideProgressBar={true}
          ></ToastContainer>
      </div>
    )};
  }
}

export default App;
